import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import BatterjeeGroup from "./pages/BatterjeeGroup";
import Team from "./pages/Team";
import History from "./pages/History";
import Vademecum from "./pages/Vademecum";

/* Commitment child pages */
import WithThePeople from "./commitment/WithThePeople";
import Ethics from "./commitment/Ethics";
import Environmental from "./commitment/Environmental";
import SustainableDevelopment from "./commitment/SustainableDevelopment";

/* ✅ QUALITY PAGES */
import QualityPage from "./quality/quality"; 
import ProductionPlants from "./quality/production-plants";

import ComprehensiveSolutions from "./b2b/ComprehensiveSolutions";
import TeamB2B from "./b2b/Team";
import Pipeline from "./b2b/Pipeline";
import ManufacturingPlant from "./b2b/ManufacturingPlant";

function App() {
  return (
    <Router>
      <Header />

      <div className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/batterjee-group" element={<BatterjeeGroup />} />
          <Route path="/team" element={<Team />} />
          <Route path="/history" element={<History />} />
          <Route path="/vademecum" element={<Vademecum />} />

          {/* COMMITMENT SUB-PAGES */}
          <Route path="/commitment/with-the-people" element={<WithThePeople />} />
          <Route path="/commitment/ethics" element={<Ethics />} />
          <Route path="/commitment/environmental" element={<Environmental />} />
          <Route
            path="/commitment/sustainable-development"
            element={<SustainableDevelopment />}
          />

          {/* ✅ QUALITY ROUTES */}
          <Route path="/quality/quality" element={<QualityPage />} />
          <Route path="/quality/production-plants" element={<ProductionPlants />} />
          <Route path="/b2b/comprehensive-solutions" element={<ComprehensiveSolutions />}/>
          <Route path="/b2b/team" element={<TeamB2B />}/>
          <Route path="/b2b/pipeline" element={<Pipeline />}/>
          <Route path="/b2b/manufacturing-plants" element={<ManufacturingPlant />}/>
        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;